import React, { useState, useEffect, useCallback } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, Cell } from 'recharts';
import { getNumbersWithDecimalPlaces } from '../../utilities/money';
import { CHAIN_COLORS } from '../../constants/chain_colors';
import EmptyState from '../EmptyState';
import { EXCHANGES } from '../../constants/exchange';
import { getChainInfo } from '../../utilities/chain';
import { capitalizeLetters } from '../../utilities/capitalize';

const BarChartComponent = (props) => {
  const { data, direction } = props;
  const [chainSplit, setChainSplit] = useState([]);
  const chainSplitCalculator = useCallback(() => {
    if (!data) return [];
    let chainSplit = Object.keys(data).map((key) => {
      return { name: key.toUpperCase(), value: data[key], key: key };
    });
    const totalValueOfAllChain = chainSplit
      .map((chain) => chain.value)
      .reduce((partialSum, currentValue) => partialSum + currentValue, 0);
    let chainSplitByPercentage = chainSplit
      .map((eachChainSplit) => {
        let percentageAllocation = (eachChainSplit.value / totalValueOfAllChain) * 100;
        return {
          name: `${eachChainSplit.name} ${getNumbersWithDecimalPlaces(percentageAllocation, 5)} %`,
          value: eachChainSplit.value,
          key: eachChainSplit.key,
        };
      })
      .filter((chain_split) => chain_split.value > 0);
    /**
     * Sorting the values by descending order according to value
     */
    chainSplitByPercentage.sort((a, b) => {
      return b.value - a.value;
    });
    /**
     * Only showing 7 highest chain
     */
    chainSplitByPercentage = chainSplitByPercentage.slice(0, 7);
    setChainSplit(chainSplitByPercentage);
  }, [data]);

  const renderLegend = () => {
    return (
      <ul>
        {chainSplit.map((entry, index) => {
          return (
            <li
              key={`item-${index}`}
              className="recharts-legend-item legend-item-0"
              style={{ display: 'inline-block', marginRight: '10px' }}
            >
              <svg
                className="recharts-surface"
                width="14"
                height="14"
                viewBox="0 0 32 32"
                version="1.1"
                style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
              >
                <path
                  stroke="none"
                  fill={CHAIN_COLORS[entry.key]}
                  d="M0,4h32v24h-32z"
                  className="recharts-legend-icon"
                ></path>
              </svg>
              <span
                className="recharts-legend-item-text"
                style={{ color: CHAIN_COLORS[entry.key] }}
              >
                {entry.name}
              </span>
            </li>
          );
        })}
      </ul>
    );
  };

  useEffect(() => {
    chainSplitCalculator();
  }, [chainSplitCalculator]);

  const legendFormatter = (value, entry) => {

    return <span >{EXCHANGES[value]}</span>;
  };

  const customizedFormatter = (key) => {
    return capitalizeLetters((getChainInfo(key)?.label || ''))
  }

  return (
    <>
      {chainSplit.length !== 0 ? (
        <ResponsiveContainer width="100%" height={275}>
          <BarChart
            width={150}
            height={40}
            data={chainSplit}
            layout={direction === 'vertical' ? 'vertical' : 'horizontal'}
          >
            <Bar dataKey="value" minPointSize={3} maxBarSize={20}>
              {chainSplit.map((entry, index) => {
                return <Cell key={`cell-${index}`} fill={CHAIN_COLORS[entry.key]} />;
              })}

              {/* {chainSplit.map((entry, index) => {
            return <LabelList dataKey={'key'} position="insideTopLeft" key={index} fill='black' />
          })} */}
            </Bar>
            {direction === 'vertical' ? (
              <>
                <XAxis type="number" />
                <YAxis type="category" dataKey="key" tick={true} tickFormatter={customizedFormatter} tickSize={3}/>
              </>
            ) : (
              <XAxis dataKey="name" tick={false} />
            )}
            <Tooltip
              cursor={false}
              wrapperStyle={{
                top: direction === 'vertical' ? '5%' : '-20%',
                left: '3%',
                zIndex: 1,
                color: '#000000',
              }}
            />
            <Legend formatter={legendFormatter} content={renderLegend} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="chain_split_height">
          <EmptyState />
        </div>
      )}
    </>
  );
};

export default BarChartComponent;
